import { Styles } from 'assets/types';
import globalLabelsCellStyles from 'assets/stylesheets/defaultStyles/labelsCell.style';

const tagsAnalyticCellStyles: Styles = theme => ({
  ...globalLabelsCellStyles(theme),
});

export default tagsAnalyticCellStyles;
